<template>
  <div class="scroll-content">
    <div class="title">
      {{title}}
    </div>
    <div class="content-consent custom-scrollbar" v-html="consent"></div>
  </div>
</template>

<script>
export default {
    props:{
        consent: String,
        title: String
    },
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import '../style/PrivacySetting.scss';
</style>

<style lang="scss">
@import "@/style/base/base.scss";
.content-consent p strong{
    color: $a-black-333333;
}
.content-consent p{
    color: $a-black-333333;
}
.content-consent strong{
    color: $a-black-333333;
}
</style>
